import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, type Analytics } from 'firebase/analytics';
import { firebaseConfig } from './config';

export const firebaseApp = initializeApp(firebaseConfig);

let analyticsInstance: Analytics | undefined;

export async function initAnalytics(): Promise<Analytics | undefined> {
  if (analyticsInstance) return analyticsInstance;

  if (typeof window === 'undefined') return undefined;

  const supported = await isSupported();
  if (!supported) return undefined;

  analyticsInstance = getAnalytics(firebaseApp);
  return analyticsInstance;
}
